import React from 'react';
import './index.scss';

// Editorial section title: heavy, uppercase, tightly set (used by every MyPanel header and the Research area).
// `title` may hold <br />s for a stacked headline.
const SectionTitle: React.FC<{ title: React.ReactNode, as?: 'h2' | 'h3', className?: string }> = ({ title, as = 'h2', className }) => {
  const Tag = as;
  return <Tag className={`section-title${className ? ` ${className}` : ''}`}>{title}</Tag>;
};

export default SectionTitle;
